import React, { useRef, useState } from 'react';
// material
import { alpha } from '@mui/material/styles';
import { Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import {useNavigate} from 'react-router-dom';

// components
// import MenuPopover from '../../components/MenuPopover';
//""
import account from '../../_mocks_/account';
import ArrowDown from "../../assets/icons/icon-dropdown.svg";
// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();


  const handleOpen = () => {
    setOpen(true);
  };

  const [anchorAccountDropdownEl, setAccountDropdownEl] = React.useState(null);
  const accountDropdownOpen = Boolean(anchorAccountDropdownEl);
  const handleAccountDropdownClick = (event) => {
    setAccountDropdownEl(event.currentTarget);
  };
  const handleAccountDropdownClose = () => {
    setAccountDropdownEl(null);
  };

  const handleAccountMenuSelect = (e) => {
    const id = e.target.id
    if(id === 'logout') {
      navigate('/logout')
      return;
    }
  }

  return (
    <>
      {/* <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
        className="user-details form_icon"
      >
        <Avatar src={account.photoURL} alt="photoURL" />
        
      </IconButton> */}
    {  !localStorage.getItem("logBookRedirect") &&
      <IconButton className="form-icon-btn"  onClick={handleAccountDropdownClick}>
        <img src={ArrowDown} className="arrow-details" />
      </IconButton>
    }
      <Menu
        className="account-navigation"
        anchorEl={anchorAccountDropdownEl}
        open={accountDropdownOpen}
        onClose={handleAccountDropdownClose}
        onClick={handleAccountMenuSelect}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 2,
            ml: {xs: '15px', sm: '25px'},
            borderRadius: '8px',
            width: {xs: '160px', sm: '185px', md: '185px'},
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: 0,
              mr: 0,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 30,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >

          
          {/* <MenuItem className='text-anchor'>My Account</MenuItem>
          <MenuItem className='text-anchor'>Dashboard</MenuItem>  
          <MenuItem className='text-anchor'>Subscription</MenuItem>
          <MenuItem className='text-anchor'>Redeem Voucher</MenuItem> 
          <MenuItem className='text-anchor'>T&C/Privacy Policy</MenuItem>
          <MenuItem className='text-anchor'>FAQs</MenuItem>  */}

          { 
            !localStorage.getItem("logBookRedirect") &&
            <MenuItem className='text-anchor' id="logout">Logout</MenuItem>
          }
      </Menu>
    </>             
  );
}
